import MenuUno from "./components/MenuUno.vue";
import MenuDue from "./components/MenuDue.vue";
import TestList from "./components/TestList.vue";

export default {
    MenuUno,
    MenuDue,
    TestList,
};
